import * as Server from '../models/server/index';
import * as Models from '../models/index';
import { api } from '../infrastructure/call.api';

export const loadQuestions = (contract: { username: string }) => {
	return api
		.get<Server.Recovery.QuestionModelResponse_Server[]>('/api/recovery/getquestions', contract)
		.then(response => response.map(r => Server.Recovery.map_QuestionModelResponse(r)));
};
export const sendAnswers = (contract: Server.Recovery.AnswerSecretPackContract) => {
	return api.post<boolean>('/api/recovery/answersecretquestions', contract).then(response => response);
};
export const resetPassword = (contract: Server.Recovery.ResetPasswordContract) => {
	return api
		.post<Models.ResetPasswordResponse_Server>('/api/recovery/resetpassword', contract)
		.then((response: Models.ResetPasswordResponse_Server) => ({
			data: response.Data,
			message: response.Message,
			status: response.Status,
		}));
};
export const resetExpiredPassword = (contract: Server.Recovery.ResetExpiredPasswordContract) => {
	return api
		.post<Models.ResetPasswordResponse_Server>('/api/recovery/ResetExpiredPassword', contract)
		.then((response: Models.ResetPasswordResponse_Server) => ({
			data: response.Data,
			message: response.Message,
			status: response.Status,
		}));
};

export const changeUserPassword = (contract: Server.Recovery.ChangePasswordIsForsedContract & Server.Recovery.ResetExpiredPasswordContract) => {
	return api
		.post<Models.ResetPasswordResponse_Server>('/api/recovery/ChangePasswordIsForsed', contract)
		.then((response: Models.ResetPasswordResponse_Server) => ({
			data: response.Data,
			message: response.Message,
			status: response.Status,
		}));
};

export const changePasswordAndSubmitSecretAnswers = (
	contract: Server.Recovery.ChangePasswordIsForsedContract & Server.Recovery.ResetExpiredPasswordContract & Models.SecretAnswers_Contract
) => {
	return api
		.post<Models.ResetPasswordResponse_Server>('/api/recovery/ChangePasswordAndSubmitSecretAnswersV2', contract)
		.then((response: Models.ResetPasswordResponse_Server) => ({
			data: response.Data,
			message: response.Message,
			status: response.Status,
			isSuccess: response.IsSuccess,
		}));
};

export const validateUserPassword = (contract: Models.ValidateUserPassword_Contract_Client) => {
	return api
		.post<Models.ValidateUserPassword_Response_Server[]>('/api/recovery/ValidateUserPassword', contract)
		.then((response: Models.ValidateUserPassword_Response_Server[]) => {
			return response.map(el => Models.map_ValidateUserPassword_Response(el));
		});
};

export const validateOldPassword = (contract: Models.ValidateOldPassword_Contract_Client) => {
	return api
		.post<Models.ValidateUserPassword_Response_Server>('/api/recovery/ValidateOldPassword', contract)
		.then((response: Models.ValidateUserPassword_Response_Server): Models.ValidateUserPassword_Response_Client => {
			if (!response) return null;
			return {
				test: response.TestName,
				isPassed: response.IsPassed,
			};
		});
};

export const checkResetAnswersByUserName = (contract: { userName: string }) => {
	return api
		.get<Models.CheckSecretAnswersByUserName_Response_Server[]>('/api/recovery/CheckSecretAnswersByUserName', contract)
		.then(response => response.map(el => Models.map_CheckSecretAnswersByUserName_Response(el)));
};
